import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapComponent } from './map.component';
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';



@NgModule({
  declarations: [
    MapComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatProgressSpinnerModule
],
  exports:[
    MapComponent
  ]
})
export class MapModule { }
